import { TagGroup } from "rsuite";
import { Icon, IconButton, Tag } from "../..";
import "./MessageBox.css";

const MessageBox = ({
  position,
  message,
  messageFiles = [],
  type,
  onResend,
  showCoppyButton = false,
}) => {
  return (
    <div
      className={`chat-message-box__root ${
        position === "right"
          ? "chat-message-box__root--right"
          : "chat-message-box__root--left"
      }`}
    >
      {showCoppyButton && (
        <button
          onClick={() => {
            navigator.clipboard.writeText(message);
            alert("Message copied to clipboard!");
          }}
        >
          <Icon icon="copy" />
        </button>
      )}
      <div
        className={`chat-message-box__box ${
          position === "right"
            ? "chat-message-box__box--right"
            : "chat-message-box__box--left"
        } 
        ${type === "error" ? "chat-message-box__box--error" : ""}
        `}
      >
        {type === "error" && (
          <IconButton
            color="red"
            onClick={onResend}
            className="chat-message-box__resend-btn"
            icon={<Icon icon="repeat" />}
            circle
          />
        )}
        <div>{message}</div>
        {messageFiles && messageFiles.length > 0 && (
          <TagGroup
            className="chat-message-box__file-list"
            style={{ marginTop: 8 }}
          >
            {messageFiles.map((file) => (
              <Tag key={file.fileId} color="blue" style={{ marginRight: 6 }}>
                <Icon icon="file" style={{ marginRight: 4 }} />
                {file.fileName}
              </Tag>
            ))}
          </TagGroup>
        )}
      </div>
      <div className="dateContainer">
        <span
          className={position === "right" ? "date-right" : "date-left"}
        ></span>
      </div>
    </div>
  );
};

export default MessageBox;
